export const HIDE_MODAL_POST = 'HIDE_MODAL_POST';
export const SHOW_MODAL_POST = 'SHOW_MODAL_POST';
export const SET_NEW_POST = 'SET_NEW_POST';
export const SET_ALL_POST = 'SET_ALL_POST';
export const CLEAR_ALL_POST = 'CLEAR_ALL_POST';